import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DescripcionFormGroup = () => {
  return (
    <Form.Group>
      <Form.Label text='DESCRIPCION' md={4} />
      <Col md={8}>
        <Field name='descripcion'>{({ field }) => <Form.InputText {...field} id='descripcion' name='descripcion' />}</Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(DescripcionFormGroup)
